import { useAuthContext, useDCContext } from "@src/context";
import { useManagerContext } from "@src/context/managerContext";
import { SignolUtils, AppUtils } from "@src/utils";
import ManagerHooks from "@src/context/hooks/managerHooks";
import {
  BehaviourSuccessOrSavingsOverTime,
  BehaviourSuccessOrSavingsPerOperator,
} from "@src/components/cards/manager";
import { CardContainer } from "@src/components/cards";
import { Loader, Tooltip } from "@src/components/atoms";
import PieChartLib from "@src/components/graphs/PieChart";
import BehaviourSuccessOrSavingsChangeSpeedometer from "@src/components/cards/manager/BehaviourSuccessOrSavingsChangeSpeedometer";

/** Very similar to PerformanceFuelSavingsSection */
const PerformanceSuccessRateSection = () => {
  const { selectedBehaviour, selectedTeam } = useManagerContext();
  const { getDynamicReplacement } = useDCContext();
  const auth = useAuthContext();

  //Data
  const {
    data: dataOverTime = {},
    isPending: isPendingDataOverTime,
    error: errorDataOverTime,
  } = ManagerHooks.useGetBehaviourSuccessOverTime(
    auth.activeRole,
    selectedBehaviour.behaviourKey,
    selectedTeam?.id,
  );
  const {
    data: dataPerOperator = [],
    isPending: isPendingDataPerOperator,
    error: errorDataPerOperator,
  } = ManagerHooks.useGetBehaviourSuccessPerOperator(
    auth.activeRole,
    selectedBehaviour.behaviourKey,
    selectedTeam?.id,
  );

  const operatorCount = dataPerOperator.length;
  const operatorsBetterThanPreSignol = dataPerOperator.reduce(
    (sum, o) => sum + (o.betterThanPreSignol ? 1 : 0),
    0,
  );

  return (
    <section className="px-8 md:px-12 py-6 flex flex-col items-center gap-6">
      <div className="font-extrabold text-2xl md:text-4xl m-0 mb-6">
        {getDynamicReplacement(
          "fuel_manager__behaviour__success_section__title",
        )}
      </div>
      <div className="m-0 mb-6">
        {getDynamicReplacement(
          "fuel_manager__behaviour__success_section__subtitle",
        )}
      </div>
      <div className="w-full flex flex-col lg:flex-row justify-center gap-4">
        <div className="w-full lg:w-1/2 md:mb-0">
          {isPendingDataOverTime ? (
            <CardContainer>
              <Loader size="xl" />
            </CardContainer>
          ) : errorDataOverTime ? (
            <div className="text-red-500">
              Error fetching success rate data...
            </div>
          ) : (
            <BehaviourSuccessOrSavingsOverTime
              periods={dataOverTime.periods}
              baseline={dataOverTime.baseline}
              successChart={true}
            />
          )}
        </div>
        <div className="w-full lg:w-1/3 self-start">
          {errorDataPerOperator ? (
            <div className="text-red-500">Error fetching operator data...</div>
          ) : (
            <BehaviourSuccessOrSavingsChangeSpeedometer
              isPending={isPendingDataPerOperator}
              valueImproved={operatorsBetterThanPreSignol}
              valueTotal={operatorCount}
              isSuccessRate={true}
            />
          )}
        </div>
      </div>
      <div className="w-full lg:w-5/6">
        {errorDataPerOperator ? (
          <div className="text-red-500">Error fetching operator data...</div>
        ) : (
          <BehaviourSuccessOrSavingsPerOperator
            data={dataPerOperator}
            isLoading={isPendingDataPerOperator}
          />
        )}
      </div>
    </section>
  );
};

export const performanceSuccessRateSectionControls = {};
PerformanceSuccessRateSection.propTypes = AppUtils.getPropTypeFromControls(
  performanceSuccessRateSectionControls,
);
export default PerformanceSuccessRateSection;
